import { Button, Card, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { routesProfile } from '../../../consts'

type Props = {
  message?: string | null
}

export function SocialOrderAccessRestrictedStub({ message }: Props) {
  const navigate = useNavigate()

  return (
    <Stack alignItems="center" justifyContent="center" minHeight="60vh" px={2}>
      <Card variant="primaryAdaptiveCard" sx={{ p: 3, maxWidth: 480, width: '100%' }}>
        <Stack gap={2}>
          <Typography variant="black-16-semiBold">Доступ к соцзаказу ограничен</Typography>
          <Typography variant="black-14-light" color="text.secondary">
            {message?.trim() ||
              'Вы не можете просматривать этот социальный заказ. Обратитесь к автору.'}
          </Typography>
          <Stack direction="row">
            <Button variant="follow" onClick={() => navigate(`/${routesProfile.SOCIALORDERS.path}`)}>
              К списку соцзаказов
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  )
}
